const getBookmarks = (state) => {
  if (!state.bookmarks) return

  return state.bookmarks
    .sort((a, b) => (a.page > b.page) ? 1 : -1)
}

export default {
  getBookmarks
}
